import React, { useState, useEffect } from 'react';

const Footer = () => {
    // 1. Setup State to hold the dynamic contact info
    // We set your current hardcoded info as the default fallback
    const [contactInfo, setContactInfo] = useState({
        address: 'Swabi, Khyber Pakhtunkhwa, Pakistan',
        email: 'kskccsinfo@gmail.com',
        phone: '0938-430541',
        hours: 'Mon - Fri: 8:00 AM - 4:00 PM'
    });

    // 2. Fetch the dynamic data from your backend when the component loads
    useEffect(() => {
        // Update this URL to point exactly to where you placed the PHP file on cPanel
        fetch('https://sherianalumni.com/api/get_settings.php') 
            .then(response => response.json())
            .then(data => {
                if (data && !data.error) {
                    setContactInfo({
                        address: data.address || contactInfo.address,
                        email: data.email || contactInfo.email,
                        phone: data.phone || contactInfo.phone,
                        hours: data.hours || contactInfo.hours
                    });
                }
            })
            .catch(error => {
                console.error("Failed to fetch contact info:", error);
            });
    }, []);

    return (
        <footer className="sherian-footer">
            <style>{`
                .sherian-footer {
                    /* UPDATED TO PREMIUM SHERIAN GREEN */
                    background-color: #134628; 
                    color: #ffffff;
                    padding: 80px 0 30px;
                    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                    border-top: 5px solid #ffc300;
                }

                .footer-container {
                    max-width: 1200px;
                    margin: 0 auto;
                    display: flex;
                    align-items: flex-start; 
                    justify-content: space-between;
                    flex-wrap: wrap;
                    gap: 40px;
                    padding: 0 25px;
                }

                .footer-section {
                    flex: 1;
                    min-width: 280px;
                }

                .footer-brand h2 {
                    color: #ffc300;
                    font-weight: 800;
                    letter-spacing: 3px;
                    margin-top: 0;
                    margin-bottom: 20px;
                    text-transform: uppercase;
                    font-size: 1.5rem;
                }

                .footer-brand p {
                    line-height: 1.7;
                    font-size: 0.95rem;
                    opacity: 0.8;
                }

                .footer-section h4 {
                    color: #ffc300;
                    font-size: 1.2rem;
                    margin-top: 0; 
                    margin-bottom: 20px;
                    text-transform: uppercase;
                    border-left: 3px solid #ffc300;
                    padding-left: 10px;
                }

                .footer-links {
                    list-style: none;
                    padding: 0;
                }

                .footer-links li { margin-bottom: 12px; }

                .footer-links a {
                    color: #ffffff;
                    text-decoration: none;
                    opacity: 0.7;
                    transition: 0.3s;
                    display: flex;
                    align-items: center;
                }

                .footer-links a:hover {
                    color: #ffc300;
                    opacity: 1;
                    transform: translateX(5px);
                }

                .contact-info p {
                    display: flex;
                    align-items: flex-start;
                    gap: 12px;
                    margin-bottom: 15px;
                    opacity: 0.8;
                    font-size: 0.95rem;
                }

                .contact-info i {
                    color: #ffc300;
                    margin-top: 4px;
                }

                .social-icons {
                    display: flex;
                    gap: 12px;
                    margin-top: 25px;
                }

                .social-icon {
                    width: 38px;
                    height: 38px;
                    background: rgba(255, 255, 255, 0.05);
                    color: #ffc300;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                    text-decoration: none;
                    border: 1px solid rgba(255, 195, 0, 0.2);
                    transition: 0.3s;
                }

                @media (max-width: 768px) {
                    .footer-container {
                        flex-direction: column;
                        align-items: flex-start;
                    }
                }

                .footer-bottom {
                    margin-top: 60px;
                    padding-top: 30px;
                    border-top: 1px solid rgba(255, 255, 255, 0.1);
                    text-align: center;
                    font-size: 0.8rem;
                    opacity: 0.5;
                }
            `}</style>

            <div className="footer-container">
                <div className="footer-section">
                    <div className="footer-brand">
                        <h2>SHERIAN <br/>Alumni Association</h2>
                        <p>
                            Building a global network for the legacy of Karnal Sher Khan Cadet College Swabi. 
                            Once a Cadet, always a Sherian.
                        </p>
                    </div>
                    <div className="social-icons">
                        <a href="https://www.facebook.com/share/19LHebvM5W/" className="social-icon"><i className="fab fa-facebook-f"></i></a>
                        <a href="https://www.instagram.com/sherianalumniassociation?igsh=eml0bG1qOXl1MTdl" className="social-icon"><i className="fab fa-instagram"></i></a>
                        <a href="https://chat.whatsapp.com/IsI2RBQvBwh4lk8GlaKVAD" className="social-icon"><i className="fab fa-whatsapp"></i></a>
                    </div>
                </div>

                <div className="footer-section">
                    <h4>QUICK LINKS</h4>
                    <ul className="footer-links">
                        <li><a href="/">Home Feed</a></li>
                        <li><a href="/register">Alumni Registration</a></li>
                        <li><a href="/about">About College</a></li>
                        <li><a href="/login">Member Login</a></li>
                    </ul>
                </div>

                <div className="footer-section contact-info">
                    <h4>CONTACT US</h4>
                    {/* 3. Render the dynamic state values here */}
                    <p><i className="fas fa-map-marker-alt"></i> <span>{contactInfo.address}</span></p>
                    <p><i className="fas fa-envelope"></i> <span>{contactInfo.email}</span></p>
                    <p><i className="fas fa-phone-alt"></i> <span>{contactInfo.phone}</span></p>
                    <p><i className="fas fa-clock"></i> <span>{contactInfo.hours}</span></p>
                </div>
            </div>

            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} Sherian Alumni Portal | Karnal Sher Khan Cadet College Swabi</p>
            </div>
        </footer>
    );
};

export default Footer;